import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlainFooterComponent } from './plain-footer/plain-footer.component';

@NgModule({
  declarations: [PlainFooterComponent],
  imports: [CommonModule],
  exports: [PlainFooterComponent],
})
export class PlainFooterModule {}
